import { Pipe, PipeTransform } from '@angular/core';
import { SLATypeDetails } from '../../app-create-case/models/insurance-case.model';
import { CaseReportInfo } from '../models/domain/CaseReportInfo';
import { SCConfig } from '../../sc-config/constant/sc-config.constant';

@Pipe({
    name: 'slaStatusByExpireDate',
    standalone: false
})
export class SlaStatusByExpireDatePipe implements PipeTransform {
    transform(slaDetails: SLATypeDetails, caseReportList: CaseReportInfo[], readyForBillingDate: any): any {
        if (!slaDetails?.SLAExpiredDate) return 'grey';

        caseReportList = caseReportList ? caseReportList : [];
        let slaBillingDate = new Date();

        if (readyForBillingDate) {
            slaBillingDate = new Date(readyForBillingDate);
        } else if (caseReportList.length > 0) {
            const caseReport = caseReportList.find(
                x => x.IsEmailSent && x.EmailSendingStatus === SCConfig.EmailSendingStatus.SUCCESS
            );
            slaBillingDate = caseReport ? new Date(caseReport.GenerationDate) : new Date();
        }

        const expireDateUtcToCurrentTime = new Date(slaDetails.SLAExpiredDate);

        // adjusted daylight saving time by timeZone
        const timezoneOffsetInMinutes = Math.abs(expireDateUtcToCurrentTime.getTimezoneOffset());
        expireDateUtcToCurrentTime.setMinutes(expireDateUtcToCurrentTime.getMinutes() - timezoneOffsetInMinutes);

        let difference: number = slaBillingDate.getTime() - expireDateUtcToCurrentTime.getTime();
        let resultInMinutes = Math.floor(difference / 60000);

        if (difference > 0) return 'red';
        resultInMinutes = Math.abs(resultInMinutes);
        const date = new Date(slaDetails.SLAExpiredDate);
        if (resultInMinutes >= 0 && resultInMinutes < 720) return 'orange';
        else if (resultInMinutes >= 720 && resultInMinutes < 1440) return 'yellow';
        else return 'grey';
    }
}
